import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogProps, Paragraph } from '@expressable/syntax-ds';

type Props = DialogProps & { onConfirm: () => void };

export const DirectSignupEditAppointmentDialog = ({ onConfirm, ...dialogProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog {...dialogProps}>
      <Dialog.Body>
        <Dialog.Title>{t('directSignup.dialogs.editAppointment.title')}</Dialog.Title>
        <Paragraph>{t('directSignup.dialogs.editAppointment.body')}</Paragraph>
      </Dialog.Body>

      <Dialog.CTAs>
        <Button onClick={onConfirm}>{t('directSignup.dialogs.editAppointment.confirm')}</Button>

        <Button variant="ghost" onClick={dialogProps.onDismiss}>
          {t('directSignup.dialogs.editAppointment.cancel')}
        </Button>
      </Dialog.CTAs>
    </Dialog>
  );
};
